import type { FarmBalance, FarmBalanceAmounts } from "../types/farmBalanceTypes.ts"

const sumNullable = (a: number | null, b: number | null): number | null =>
  a == null && b == null ? null : (a ?? 0) + (b ?? 0)

export const getFarmBalanceAmounts = (balance: FarmBalance): FarmBalanceAmounts => {
  const penaltyVolume =
    balance.penaltyThreshold != null
      ? Math.max(0, balance.volumeOut - balance.penaltyThreshold)
      : null

  const royaltyAmount = balance.royaltyRate != null ? balance.volumeIn * balance.royaltyRate : null
  const penaltyAmount =
    penaltyVolume != null && balance.penaltyRate != null
      ? penaltyVolume * balance.penaltyRate
      : null

  return {
    volumeIn: balance.volumeIn,
    volumeOut: balance.volumeOut,
    net: balance.volumeIn - balance.volumeOut,
    penaltyVolume,
    penaltyRoyalty: sumNullable(royaltyAmount, penaltyAmount),
  }
}

export const sumFarmBalanceAmounts = (amounts: FarmBalanceAmounts[]): FarmBalanceAmounts =>
  amounts.reduce(
    (total, a) => ({
      volumeIn: total.volumeIn + a.volumeIn,
      volumeOut: total.volumeOut + a.volumeOut,
      net: total.net + a.net,
      penaltyVolume: sumNullable(total.penaltyVolume, a.penaltyVolume),
      penaltyRoyalty: sumNullable(total.penaltyRoyalty, a.penaltyRoyalty),
    }),
    { volumeIn: 0, volumeOut: 0, net: 0, penaltyVolume: null, penaltyRoyalty: null },
  )
